import { computed, getCurrentInstance } from "@vue/composition-api";

export default function useBreakPoints() {
  const vm = getCurrentInstance();

  const isMobile = computed(() => vm && vm.$screen.mobile && !vm.$screen.tablet);
  const tabletUp = computed(() => vm && vm.$screen.tablet);
  const smallDesktopUp = computed(() => vm && vm.$screen.small_desktop);
  const largeDesktopUp = computed(() => vm && vm.$screen.large_desktop);

  return {
    isMobile,
    tabletUp,
    smallDesktopUp,
    largeDesktopUp,
  };
}
